import BrandProgress from './brand/BrandProgress';

/**
 * Frosted overlay with the round brand loader. `message` is announced to screen readers only;
 * the loader itself is the visible cue. `fullScreen` covers the viewport, otherwise the nearest
 * positioned parent.
 */
const BrandedLoader = ({ active = true, message = 'Loading...', fullScreen = true }) => {
  if (!active) return null;

  return (
    <div className={`lmf-loader-overlay${fullScreen ? ' is-fullscreen' : ''}`}>
      <BrandProgress variant="bare" size={112} label={message} />
    </div>
  );
};

export default BrandedLoader;
